export const ARTIST_IMAGES = {
 path: 'images'
};

